// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TickIcon$LiteracyplanetTupperware from "../v2/TickIcon.res.mjs";
import * as CrossIcon$LiteracyplanetTupperware from "../v2/CrossIcon.res.mjs";
import * as V3ClozeChoiceProvider$LiteracyplanetTupperware from "./V3ClozeChoiceProvider.res.mjs";

var overClassName = "PilotClozeChoiceProvider-overClassName bg-[#d2dcf0] text-[#d2dcf0] select-none inline-block";

var dropClassName = "PilotClozeChoiceProvider-dropClassname bg-[#f2f6f8] text-[#f2f6f8] select-none inline-block";

function PilotClozeChoiceProvider$HiddenDrag(props) {
  var __marked = props.marked;
  var marked = __marked !== undefined ? __marked : false;
  return React.createElement("div", {
              style: {
                cursor: marked ? "default" : "pointer",
                opacity: "0.5",
                userSelect: "none"
              },
              onClick: props.onClick
            }, props.children);
}

var HiddenDrag = {
  make: PilotClozeChoiceProvider$HiddenDrag
};

function renderDragOverlayComponent(children) {
  return React.createElement("div", {
              className: "PilotClozeChoiceProvider-overlayComponent whitespace-nowrap	bg-[#f2f6f8] cursor-pointer text-lg leading-10"
            }, children);
}

function renderAlreadyDraggedPlaceholder(onClick, children) {
  return React.createElement(PilotClozeChoiceProvider$HiddenDrag, {
              onClick: onClick,
              children: children
            });
}

function renderAlreadyDraggedAndMarkedPlaceholder(onClick, children) {
  return React.createElement(PilotClozeChoiceProvider$HiddenDrag, {
              marked: true,
              onClick: onClick,
              children: children
            });
}

function renderDroppedComponent(onClick, children) {
  return React.createElement("button", {
              className: "PilotClozeChoiceProvider-droppedComponent text-black cursor-pointer block",
              onClick: onClick
            }, children);
}

function renderCorrectDroppedComponent(onClick, children) {
  return React.createElement("div", {
              className: "PilotClozeChoiceProvider-correctDroppedComponent min-w-[100px] text-black flex gap-2 items-center justify-center bg-lpTickBackground",
              onClick: onClick
            }, React.createElement(TickIcon$LiteracyplanetTupperware.make, {
                  className: "w-5 fill-lpTick"
                }), children);
}

function renderIncorrectDroppedComponent(onClick, children) {
  return React.createElement("div", {
              className: "PilotClozeChoiceProvider-incorrectDroppedComponent min-w-[100px] text-black flex gap-2 items-center justify-center bg-lpCrossBackground",
              onClick: onClick
            }, React.createElement(CrossIcon$LiteracyplanetTupperware.make, {
                  className: "w-5 fill-lpCross"
                }), children);
}

function PilotClozeChoiceProvider(props) {
  return React.createElement(V3ClozeChoiceProvider$LiteracyplanetTupperware.make, {
              overClassName: overClassName,
              dropClassName: dropClassName,
              renderDragOverlayComponent: renderDragOverlayComponent,
              renderAlreadyDraggedPlaceholder: renderAlreadyDraggedPlaceholder,
              renderAlreadyDraggedAndMarkedPlaceholder: renderAlreadyDraggedAndMarkedPlaceholder,
              renderDroppedComponent: renderDroppedComponent,
              renderCorrectDroppedComponent: renderCorrectDroppedComponent,
              renderIncorrectDroppedComponent: renderIncorrectDroppedComponent,
              questionIndex: props.questionIndex,
              children: props.children
            });
}

var make = PilotClozeChoiceProvider;

var $$default = PilotClozeChoiceProvider;

export {
  overClassName ,
  dropClassName ,
  HiddenDrag ,
  renderDragOverlayComponent ,
  renderAlreadyDraggedPlaceholder ,
  renderAlreadyDraggedAndMarkedPlaceholder ,
  renderDroppedComponent ,
  renderCorrectDroppedComponent ,
  renderIncorrectDroppedComponent ,
  make ,
  $$default as default,
}
/* react Not a pure module */
